// extracted by mini-css-extract-plugin
export default {"error-section":"style_error-section__l32XR","errorSection":"style_error-section__l32XR","job-bid-form":"style_job-bid-form__tlCH5","jobBidForm":"style_job-bid-form__tlCH5"};